import { MIDDLE_EAST_CLOUD_FRAGMENTS } from '../constants';

/**
 * util to check if the passed country is arabic country
 * @param {String} country
 * @returns boolean
 */
const isArabic = country => {
  if (MIDDLE_EAST_CLOUD_FRAGMENTS.includes(country?.cloudUrlFragment)) {
    return true;
  }
  return false;
};

export { isArabic };
